module.exports = __webpack_public_path__ + "static/media/Scoutify-App-Article-Image.d1095fee.png";